import React, { useEffect,  useRef } from "react";

import { Row, Col } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import FASTable from "../../../../../components/Tables/FASTable";
import { useDispatch, useSelector } from "react-redux";
import {
  AccountFun,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Ac_Confirmation({
  accountGroup,
  accountName,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { LedgerNormaldata } = useSelector((state) => state.LedgerSlice);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const getRows = LedgerNormaldata?.LedgerDtl?.map((label, index) => ({
    // srNumber: index + 1,
    Date: formatDateToDDMMYYYY(label.Date),
    Type: label.Type,
    VouNo: label.VouNo,
    ChqNo: label.ChqNo,
    Narration: label.Narration,
    Debit: (parseFloat(label.Debit) || 0).toFixed(2),
    Credit: (parseFloat(label.Credit) || 0).toFixed(2),
    Balance: (parseFloat(label.Balance) || 0).toFixed(2),
    AmtType: label.AmtType,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Date", key: "Date", align: "center" },
    {
      label: "Type",
      key: "Type",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Vou No", key: "VouNo", align: "right" },
    { label: "Chq No", key: "ChqNo", align: "right" },
    {
      label: "Narration",
      key: "Narration",
      align: "left",
      width: "300px",
      wrap: true,
    },
    { label: "Debit", key: "Debit", align: "right", format: true },
    { label: "Credit", key: "Credit", align: "right", format: true },
    { label: "Balance", key: "Balance", align: "right", format: true },
    { label: "bal Type", key: "AmtType", align: "right" },
  ];

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    dispatch(AccountFun());
    // dispatch(
    //   LedgerNormal({
    //     Firm,
    //     Year: FinancialYear,
    //     selectedIds: accountGroup,
    //     AcIDs: accountName,
    //     startDate: startDate,
    //     endDate: endDate,
    //   }),
    // );
  }, [accountGroup, accountName, dispatch]);

  const formatIndianAmount = (value) => {
    if (!value) return "0.00";

    const str = String(value).trim();

    // Number extract
    const numberMatch = str.match(/-?\d+(\.\d+)?/);

    if (!numberMatch) return value;

    const num = Number(numberMatch[0]);

    // Cr / Dr extract
    const typeMatch = str.match(/\b(Cr|Dr)\b/i);
    const type = typeMatch ? typeMatch[0] : "";

    const formattedNumber = num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formattedNumber} ${type}`.trim();
  };

  const handleDownload = () => {
    const doc = new jsPDF({ orientation: "landscape", format: "a4" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;
    let cursorY = 20;

    doc.setFont("helvetica", "normal");

    // ================= TITLE (MATCH UI STYLE) =================
    // ---------------- TITLE ----------------
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    doc.text("A/C Confirmation Report", pageWidth / 2, 15, {
      align: "center",
    });

    // LINE TITLE KE NICHE
    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    // CURSOR POSITION
    cursorY = 35;

    // ================= TOP SECTION (LIKE YOUR UI CARD) =================

    const toParty = LedgerNormaldata?.LedgerOpening?.[0] || {};
    const summary = LedgerNormaldata?.LedgerSumm?.[0] || {};

    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    let yPos = 35;

    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");

    doc.text(`A/c Name : ${toParty?.AcName || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`Pan No : ${toParty?.PanNo || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`Address : ${toParty?.Address || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`City : ${toParty?.CityName || "-"}`, marginX, yPos);

    const rightEdge = pageWidth - marginX;

    doc.setFont("helvetica", "bold");

    const openingText = `Opening : ${formatIndianAmount(
      toParty?.OpAmount || 0,
    )}`;

    const balanceText = `Balance : ${formatIndianAmount(
      summary?.Balance || 0,
    )}`;

    doc.text(openingText, rightEdge - doc.getTextWidth(openingText), 50);

    doc.text(balanceText, rightEdge - doc.getTextWidth(balanceText), 57);
    // ================= SEPARATOR LINE (LIKE CARD DIVIDER) =================
    yPos += 14;

    doc.line(marginX, yPos, pageWidth - marginX, yPos);

    cursorY = yPos + 7;
    // ================= TABLE =================

    // TOTALS

    const totalDebit =
      summary?.Debit || summary?.TotalDebit || summary?.DrAmt || 0;

    const totalCredit =
      summary?.Credit || summary?.TotalCredit || summary?.CrAmt || 0;

    const totalBalance = summary?.Balance || 0;

    const rows =
      LedgerNormaldata?.LedgerDtl?.map((row, i) => [
        i + 1,
        row?.Date ? new Date(row.Date).toLocaleDateString("en-GB") : "-",
        row?.Type || "-",
        row?.VouNo || "-",
        row?.ChqNo || "-",
        row?.Narration || "-",
        formatIndianAmount(row?.Debit || 0),
        formatIndianAmount(row?.Credit || 0),
        formatIndianAmount(row?.Balance || 0),
        row?.AmtType || "-",
      ]) || [];

    // TOTAL ROW
    rows.push([
      "",
      "",
      "",
      "",
      "",
      "TOTAL",
      formatIndianAmount(totalDebit),
      formatIndianAmount(totalCredit),
      formatIndianAmount(totalBalance),
      "",
    ]);
    autoTable(doc, {
      startY: cursorY,

      margin: {
        left: marginX,
        right: marginX,
      },

      head: [
        [
          "Sr",
          "Date",
          "Type",
          "Vou No",
          "Chq No",
          "Narration",
          "Debit",
          "Credit",
          "Balance",
          "Type",
        ],
      ],

      body: rows,
      theme: "grid",

      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },

      columnStyles: {
        0: { cellWidth: 14, halign: "center" },
        1: { cellWidth: 22, halign: "center" },
        2: { cellWidth: 20, halign: "left" },
        3: { cellWidth: 22, halign: "center" }, // Vou No
        4: { cellWidth: 22, halign: "center" }, // Chq No
        5: { cellWidth: 70, halign: "right" }, // Narration
        6: { cellWidth: 24, halign: "right" },
        7: { cellWidth: 24, halign: "right" },
        8: { cellWidth: 24, halign: "right" },
        9: { cellWidth: 18, halign: "center" },
      },
      didParseCell: (data) => {
        if (data.section === "body") {
          if (typeof data.cell.text === "string") {
            data.cell.text = data.cell.text.trim();
          } else if (Array.isArray(data.cell.text)) {
            data.cell.text = data.cell.text.map((t) =>
              typeof t === "string" ? t.trim() : t,
            );
          }

          const colConfig = getColumns[data.column.index];

          if (colConfig) {
            data.cell.styles.halign = colConfig.align || "left";
          }
        }

        const isTotalRow = data.row.raw?.[5] === "TOTAL";

        if (isTotalRow && data.section === "body") {
          data.cell.styles.fillColor = [230, 230, 230];
          data.cell.styles.fontStyle = "bold";
        }
      },

      didDrawPage: (data) => {
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
        doc.setFontSize(8);
        doc.text(`Page ${pageNumber}`, 10, pageHeight - 5);
      },
    });

    // ================= FOOTER (LIKE UI CONFIRMATION BLOCK) =================
    const finalY = (doc.lastAutoTable?.finalY || cursorY) + 15;

    if (finalY + 20 > pageHeight) doc.addPage();

    doc.setFontSize(11);
    doc.text("I/WE HEREBY CONFIRM THE ABOVE STATEMENT", marginX, finalY);

    const signY = finalY + 18;

    doc.text("(Signature With Rubber Stamp)", marginX, signY);
    doc.text(
      "AUTHORISED SIGNATORY",
      pageWidth - marginX - doc.getTextWidth("AUTHORISED SIGNATORY"),
      signY,
    );

    doc.save("AC_Confirmation_Report.pdf");
  };

  if (accountName.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }
  if (LedgerNormaldata === "no" || LedgerNormaldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ paddingTop: "16px" }}>
      <style>{`
        .common-hover-btn {
          transition: transform 0.25s ease;
          transform: scale(1);
        }
        .common-hover-btn:hover {
          transform: scale(1.01);
        }
        .common-hover-btn:active {
          transform: scale(0.98);
        }
      `}</style>

      <Row>
        <Col xs={12}>
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              borderRadius: "16px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              padding: "24px",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7}`,
            }}
          >
            <Row className="g-4 align-items-stretch">
              {/* LEFT CONTENT */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Row className="g-3">
                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            A/c Name:
                          </span>
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "800",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.AcName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col md={6} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Pan No:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.PanNo || "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            City:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.CityName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-start",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.6",
                            }}
                          >
                            Address:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "1.6",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.Address ||
                              "-"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-end",
                    }}
                  >
                    <button
                      onClick={handleDownload}
                      className="common-hover-btn"
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour10,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                        border: "none",
                        borderRadius: "10px",
                        padding: "12px 18px",
                        fontWeight: "700",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <FiDownload size={16} />
                      Download PDF
                    </button>
                  </div>
                </div>
              </Col>

              {/* RIGHT SIDE */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: "12px",
                  }}
                >
                  {/* BOX 1 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        OPENING :
                      </span>

                      <span
                        style={{
                          fontSize: "28px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1",
                        }}
                      >
                        {formatIndianAmount(
                          LedgerNormaldata?.LedgerOpening?.[0]?.OpAmount || 0,
                        )}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>

                  {/* BOX 2 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        BALANCE :
                      </span>

                      <span
                        style={{
                          fontSize: "26px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1.2",
                        }}
                      >
                        {formatIndianAmount(
                          LedgerNormaldata?.LedgerSumm?.[0]?.Balance || 0,
                        )}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col xs={12}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                  }}
                >
                  AC_CONFIRMATION
                </h2>
              </div>
              <FASTable
                data={getRows}
                columns={getColumns}
                externalTotals={LedgerNormaldata?.LedgerSumm?.[0]}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
